import { PART_STATUSES } from '@frontend/api';

import { CAD_FILE_TYPES, UNITLESS_FILE_TYPES } from 'constants/all';

import { toCamelCase } from '../stringUtils';

export const getProcessName = (process) => {
  return (
    `${process.manufacturer.name} ${process.machine.name} ` +
    `(${process.process_class.name}, ${process.family})`
  );
};

export const canChangeUnits = (fileType) => {
  return UNITLESS_FILE_TYPES.includes((fileType || '').toLowerCase());
};

export const isThicknessRequired = (fileType) =>
  [CAD_FILE_TYPES.DXF, CAD_FILE_TYPES.DWG].includes(
    (fileType || '').toLowerCase(),
  );

export const areUnitsRequired = (fileType) => canChangeUnits(fileType);

// TODO: fix this when process tag is not header for part dfm
export const getProcessTagDfm = (processTag, dfm) => {
  if (dfm) {
    // reconcile keysToCamelCase issue with process tags with underscore
    return dfm?.[toCamelCase(processTag ?? '')] ?? [];
  } else {
    return [];
  }
};

export const isStatusInProgress = (partFileStatus) => {
  return (
    partFileStatus === PART_STATUSES.IN_PROGRESS ||
    partFileStatus === PART_STATUSES.QUEUED
  );
};

/**
 * Returns true if either processing or thumbnail creation is not yet complete
 * for a file status object (as returned by /parts/statuses/).
 * A status is "complete" when it is FINISHED or null (never started).
 */
export const isFileProcessingOrThumbnailIncomplete = (status) => {
  const processingDone =
    status?.processing?.status === PART_STATUSES.FINISHED ||
    status?.processing?.status == null;
  const thumbnailDone =
    status?.thumbnailCreation?.status === PART_STATUSES.FINISHED ||
    status?.thumbnailCreation?.status == null;
  return !processingDone || !thumbnailDone;
};
